import Papa from 'papaparse';
import { format } from 'date-fns';

export const generateFilename = (prefix, ext) => {
  const now = new Date();
  const timestamp = format(now, 'yyyy-MM-dd_HH-mm');
  return `${prefix}_${timestamp}.${ext}`;
};

export const downloadFile = (content, filename, type) => {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const exportJson = (data, prefix) => {
  const filename = generateFilename(prefix, 'json');
  downloadFile(JSON.stringify(data, null, 2), filename, 'application/json');
};

export const exportCsv = (data, prefix) => {
  const filename = generateFilename(prefix, 'csv');
  const csv = Papa.unparse(data);
  downloadFile(csv, filename, 'text/csv;charset=utf-8;');
};